/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ correct: NonNullable<unknown>, total: NonNullable<unknown> }} Game_CorrectInputs */

const bn_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} সঠিক`)
};

const de_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} richtig`)
};

const el_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} σωστό`)
};

const en_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} correct`)
};

const es_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} correcto`)
};

const fr_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} correct`)
};

const hi_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} सही`)
};

const hu_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} helyes`)
};

const id_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} benar`)
};

const it_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} corretto`)
};

const ja_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} は正解です`)
};

const ko_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} 정확함`)
};

const nl_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} juist`)
};

const pl_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} poprawne`)
};

const pt_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} correto`)
};

const ru_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} верно`)
};

const sv_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} korrekt`)
};

const tr_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} doğru`)
};

const uk_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} правильно`)
};

const vi_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} đúng`)
};

const zh_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} 正确`)
};

const zh_hant_game_correct = /** @type {(inputs: Game_CorrectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} 正確`)
};

/**
* | output |
* | --- |
* | "{correct}/{total} correct" |
*
* @param {Game_CorrectInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_correct = /** @type {((inputs: Game_CorrectInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_CorrectInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_correct(inputs)
	if (locale === "de") return de_game_correct(inputs)
	if (locale === "el") return el_game_correct(inputs)
	if (locale === "en") return en_game_correct(inputs)
	if (locale === "es") return es_game_correct(inputs)
	if (locale === "fr") return fr_game_correct(inputs)
	if (locale === "hi") return hi_game_correct(inputs)
	if (locale === "hu") return hu_game_correct(inputs)
	if (locale === "id") return id_game_correct(inputs)
	if (locale === "it") return it_game_correct(inputs)
	if (locale === "ja") return ja_game_correct(inputs)
	if (locale === "ko") return ko_game_correct(inputs)
	if (locale === "nl") return nl_game_correct(inputs)
	if (locale === "pl") return pl_game_correct(inputs)
	if (locale === "pt") return pt_game_correct(inputs)
	if (locale === "ru") return ru_game_correct(inputs)
	if (locale === "sv") return sv_game_correct(inputs)
	if (locale === "tr") return tr_game_correct(inputs)
	if (locale === "uk") return uk_game_correct(inputs)
	if (locale === "vi") return vi_game_correct(inputs)
	if (locale === "zh") return zh_game_correct(inputs)
	return zh_hant_game_correct(inputs)
});